import { List } from "antd-mobile";
import React, { useContext, useRef, useState } from "react";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import PsContext from "../../context";
import { queryParam, useQuery } from "../../utils";

const ButtonScreen = (props) => {
  const context = useContext(PsContext);
  const navigate = useNavigate();

  const [loader, setLoader] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [dataView, setDataView] = useState([]);
  const [longAbsentee, setLongAbsentee] = useState([]);

  const [markedStudents, setMarkedStudents] = useState([]);
  const [workDone, setWorkDone] = useState(null);
  const workDoneRef = useRef(null);

  let searchParams = queryParam(useQuery());
  let allowOd = context.settingValue("attendance_allow_od_by_staff") == "1";

  const stateField = (fieldName) => {
    return searchParams?.[fieldName];
  };

  const checkMarkedAttendaceStatus = (item) => {
    let m = props.markedData.find(
      (obj) => obj.student_uuid == item.uuid && obj.course == item.course
      //obj.day_value == item.day_value &&
      //obj.hour_value == item.hour_value &&
      //obj.semester == item.semester &&
      //obj.subject == item.subject &&
      //obj.teacher == item.teacher
    );
    return m;
  };

  const checkLongAbsentee = (uuid) => {
    /*let x = longAbsentee.findIndex((obj) => obj.student_uuid == uuid);
    return x > -1 ? true : false;*/
    return props.checkLongAbsentee(uuid);
  };

  const absendClick = (item, ltype = "a") => {
    if (props.absendClick) props.absendClick(item, ltype);
    /*let m = [...markedStudents];
    let index = m.findIndex((obj) => obj.student_uuid == item.uuid);

    if (index > -1) {
      let lt = m[index]["leave_type"];
      if (lt == ltype) m[index]["leave_type"] = "";
      else m[index]["leave_type"] = ltype;
      setMarkedStudents(m);
    }*/
  };

  const checkStudentMarked = (item) => {
    if (props.checkStudentMarked) return props.checkStudentMarked(item);
    /*
    let m = markedStudents;
    let index = m.findIndex((obj) => obj.student_uuid == item.uuid);
    return index > -1 && m[index]["leave_type"];*/
  };

  const getExtraButton = (item) => {
    if (checkLongAbsentee(item.uuid)) return [];

    if (
      !context.allowedAccess("mob_student_attendance", "action_update") &&
      props.markedData.length > 0
    ) {
      return [];
    }

    let sta = checkStudentMarked(item);

    let rv = [];
    if (!props.allowAttendance) return rv;
    rv.push(
      <Button
        size="md  me-2"
        variant={sta == "p" ? "success" : "light"}
        onClick={() => absendClick(item, "p")}
      >
        P
      </Button>
    );
    rv.push(
      <Button
        size="md"
        variant={sta == "a" ? "danger" : "light"}
        onClick={() => absendClick(item)}
      >
        A
      </Button>
    );
    return rv;
  };

  return (
    <>
      <List>
        {props.items.map((item, j) => {
          let sta = checkStudentMarked(item);
          return (
            <List.Item
              title={item.registerno || item.admissionno}
              description={
                <>
                  {item.name} {item.initial || ""}
                </>
              }
              className={
                sta == "a" || sta == "la"
                  ? "bg-red-50 text-danger"
                  : sta == "od"
                  ? "bg-blue-50 text-info"
                  : sta == "l"
                  ? "bg-silver-50 text-dark"
                  : null
              }
              extra={getExtraButton(item)}
            >
              {checkLongAbsentee(item.uuid) && (
                <span className="text-danger" style={{ fontSize: "10px" }}>
                  Long Absent
                </span>
              )}
            </List.Item>
          );
        })}
      </List>
    </>
  );
};
export default ButtonScreen;
